// extracted by mini-css-extract-plugin
export default {"ad":"AdBox_ad__S-vHF"};